import { TOGGLE_SIDEBAR } from "../actions/UIActions";

const initialState = {
  isSidebarOpen: true,
};

const UIReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        isSidebarOpen: !state.isSidebarOpen,
      };

    default:
      return state;
  }
};

export default UIReducer;